"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _helpers = require("@qwkin/helpers");
var _core = require("@material-ui/core");
var _ProfileItem = require("./ProfileItem.style");
var _theme = require("../utils/theme");
var _excluded = ["theme", "items", "grid", "gridColumnSize", "gridColumnSpacing", "colorRule", "paddingRule", "contentPaddingRule", "direction", "boldTitle"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * @param {{ display: boolean, label: String, value: String, action: Function, button: React.Component, children: React.Component, labelStyle: Object, valueStyle: Object, alt: String }[]} items
 */
var ProfileItem = function ProfileItem(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$grid = _ref.grid,
    grid = _ref$grid === void 0 ? false : _ref$grid,
    _ref$gridColumnSize = _ref.gridColumnSize,
    gridColumnSize = _ref$gridColumnSize === void 0 ? 6 : _ref$gridColumnSize,
    _ref$gridColumnSpacin = _ref.gridColumnSpacing,
    gridColumnSpacing = _ref$gridColumnSpacin === void 0 ? 2 : _ref$gridColumnSpacin,
    _ref$colorRule = _ref.colorRule,
    colorRule = _ref$colorRule === void 0 ? function (key) {
      return key % 2 === 0;
    } : _ref$colorRule,
    _ref$paddingRule = _ref.paddingRule,
    paddingRule = _ref$paddingRule === void 0 ? '8px 12px' : _ref$paddingRule,
    _ref$contentPaddingRu = _ref.contentPaddingRule,
    contentPaddingRule = _ref$contentPaddingRu === void 0 ? '8px 12px' : _ref$contentPaddingRu,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'row' : _ref$direction,
    _ref$boldTitle = _ref.boldTitle,
    boldTitle = _ref$boldTitle === void 0 ? false : _ref$boldTitle,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var itensGenerator = function itensGenerator() {
    return items.filter(function (item) {
      return item.display !== false;
    }).map(function (item, key) {
      var _item$labelStyle, _item$valueStyle, _item$valueStyle2;
      var ProfileItemButton = function ProfileItemButton() {
        return item !== null && item !== void 0 && item.button ? /*#__PURE__*/(0, _react.cloneElement)(item === null || item === void 0 ? void 0 : item.button, {
          color: _theme.defaultTheme.color.primary["default"]
        }) : null;
      };
      return /*#__PURE__*/_react["default"].createElement(_ProfileItem.PlainProfileBackground, {
        key: "".concat(item.label, "-").concat(item.value),
        even: colorRule(key)
      }, /*#__PURE__*/_react["default"].createElement(_ProfileItem.PlainProfileItem, {
        theme: theme,
        even: key % 2 === 0,
        paddingRule: paddingRule,
        direction: direction,
        title: item.alt
      }, /*#__PURE__*/_react["default"].createElement(_ProfileItem.PlainProfileLabel, {
        theme: theme,
        paddingRule: paddingRule,
        style: (_item$labelStyle = item === null || item === void 0 ? void 0 : item.labelStyle) !== null && _item$labelStyle !== void 0 ? _item$labelStyle : {},
        direction: direction,
        boldTitle: boldTitle
      }, item === null || item === void 0 ? void 0 : item.label), !(item !== null && item !== void 0 && item.button) && /*#__PURE__*/_react["default"].createElement(_ProfileItem.PlainProfileValue, {
        theme: theme,
        action: item === null || item === void 0 ? void 0 : item.action,
        onClick: item.action ? item.action : _helpers.identity,
        paddingRule: paddingRule,
        style: (_item$valueStyle = item === null || item === void 0 ? void 0 : item.valueStyle) !== null && _item$valueStyle !== void 0 ? _item$valueStyle : {},
        direction: direction,
        boldTitle: boldTitle
      }, item === null || item === void 0 ? void 0 : item.value), item !== null && item !== void 0 && item.button && item !== null && item !== void 0 && item.value ? /*#__PURE__*/_react["default"].createElement(_ProfileItem.ProfileValueRow, null, /*#__PURE__*/_react["default"].createElement(_ProfileItem.PlainProfileValue, {
        theme: theme,
        action: item === null || item === void 0 ? void 0 : item.action,
        onClick: item.action ? item.action : _helpers.identity,
        paddingRule: paddingRule,
        style: (_item$valueStyle2 = item === null || item === void 0 ? void 0 : item.valueStyle) !== null && _item$valueStyle2 !== void 0 ? _item$valueStyle2 : {},
        direction: direction,
        boldTitle: boldTitle
      }, item === null || item === void 0 ? void 0 : item.value), /*#__PURE__*/_react["default"].createElement(ProfileItemButton, null)) : item !== null && item !== void 0 && item.button ? /*#__PURE__*/_react["default"].createElement(ProfileItemButton, null) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)), (item === null || item === void 0 ? void 0 : item.children) && /*#__PURE__*/_react["default"].createElement(_ProfileItem.PlainProfileContent, {
        paddingRule: contentPaddingRule
      }, item === null || item === void 0 ? void 0 : item.children));
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, (0, _extends2["default"])({
    theme: theme
  }, params), grid ? /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    spacing: gridColumnSpacing
  }, itensGenerator().map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      xs: gridColumnSize,
      item: true
    }, item);
  })) : itensGenerator());
};
var _default = exports["default"] = ProfileItem;